//@ts-ignore
import request from '@/utils/request'
import { Pagination } from '../types/BaseInterface'

interface PostageParams extends Pagination {
  brand: string
  effective: boolean
} 

type PostageModel= {
  file: File,
  brands: Array<number>
}

export const postageList = (params: PostageParams) => {
  return request({
    url: "/offlineApi/postage/list",
    method: "get",
    params
  })
}

export const postageModel = (args: any, data: PostageModel) => {
  return request({
    url: "/offlineApi/postage/model",
    method: "post",
    data: data
  })
}

export const getAllProvince = () => {
  return request({
    url: "/offlineApi/postage/province",
    methd: "get"
  })
}